
import Vue from "vue";
import AppExcelMapper from "@/components/excel-mapper/ExcelMapper.vue";
import { ProductCSVImportExistingBarCodeHandling, ProductCSVImportExistingProductHandling, ProductCSVImportNewProductsHandling, ProductCSVImportProductMatchingMethod, ProductService } from "@/services/product-service";

export default Vue.extend({
	data(){
		return {
			cols: [] as string[],
			ProductService
		};
	},
	methods: {
		async onExcelMapperFile(file:File){
			await this.ProductService.importProductsExcel(file, ProductCSVImportExistingProductHandling.UPDATE,
				ProductCSVImportNewProductsHandling.CREATE,
				ProductCSVImportProductMatchingMethod.SKU,
				ProductCSVImportExistingBarCodeHandling.ERROR);
		}
	},
	async created(){
		this.cols = await this.ProductService.getImporterAllowedCols();
	},
	components: {
		AppExcelMapper
	}
});
